var AccountSidebarView = Backbone.Epoxy.View.extend({

  template: 'account.account-sidebar.accountSidebar',
  bindings: 'data-bind',

  events: {
    'click .upcoming-appointments': 'onUpcomingAppointments',
    'keydown .upcoming-appointments': 'onUpcomingAppointments',
    'click .waiting-list': 'onWaitingList',
    'keydown .waiting-list': 'onWaitingList',
    'click .wait-board': 'onWaitBoard',
    'keydown .wait-board': 'onWaitBoard',
    'click .my-reviews': 'onMyReviews',
    'keydown .my-reviews': 'onMyReviews',
    'click .service-history': 'onServiceHistory',
    'keydown .service-history': 'onServiceHistory',
    'click .logout-btn': 'onAccountLogout',
    'keydown .logout-btn': 'onAccountLogout',
    'click .profile-btn' : 'onAccountProfile',
    'keydown .profile-btn' : 'onAccountProfile',
    'click .sign-in-link': 'signInLink',
    'keydown .sign-in-link': 'signInLink',
  },

  initialize: function () {
    this.hasRendered = false;
    this.activeLink = '';
  },

  beforeRender: function() {
    if (this.hasRendered) {
      return false;
    }
    this.hasRendered = true;
    return true;
  },

  afterRender: function() {
    this.applyBindings();

    if (this.activeLink) {
      $(this.activeLink).addClass('active');
    }
  },

  cleanup: function() {
    this.removeBindings();
  },

  serialize: function() {
    return {
      client: bookedby.app.getCurrentClient().toJSON()
    };
  },

  signInLink: function(e) {
    var self = this;
    bookedby.app.showLogin(function() {
      self.parent.setData();
    });
  },

  onAccountProfile: function(e) {
      if(e.type !== "keydown" || e.type === "keydown" && e.keyCode === 13) {
          this.changeTab('profile');
      }
  },

  onUpcomingAppointments: function(e) {
      if(e.type !== "keydown" || e.type === "keydown" && e.keyCode === 13) {
          this.changeTab('upcoming-appointments');
      }
  },

  onWaitingList: function(e) {
      if(e.type !== "keydown" || e.type === "keydown" && e.keyCode === 13) {
          this.changeTab('waiting-list');
      }
  },

  onWaitBoard: function(e) {
      if(e.type !== "keydown" || e.type === "keydown" && e.keyCode === 13) {
          this.changeTab('wait-board');
      }
  },

  onMyReviews: function(e) {
      if(e.type !== "keydown" || e.type === "keydown" && e.keyCode === 13) {
          this.changeTab('client-reviews');
      }
  },

  onServiceHistory: function(e) {
      if(e.type !== "keydown" || e.type === "keydown" && e.keyCode === 13) {
          this.changeTab('service-history');
      }
  },

  onAccountLogout: function(e) {
      if(e.type !== "keydown" || e.type === "keydown" && e.keyCode === 13) {
          this.changeTab('logout');
      }
  },

  changeTab: function(route) {
    var options = {
      message: 'You have unsaved changes. Do you want to discard them?',
      cancelLabel: 'Cancel',
      confirmLabel: 'Ok',
      showCancelLabel: true
    };

    if(this.parent.hasChanges()) {
      bookedby.app.confirmForm.show(_.bind(function() {
        this.navigate(route);
      }, this), function() {}, options);
    } else {
      this.navigate(route);
    }
  },

  navigate: function(route) {
    if(route == 'logout') {
      var options = {
        message: 'Are you sure you want to logout?',
        cancelLabel: 'Go Back',
        confirmLabel: 'Logout',
        showCancelLabel: true
      };

      bookedby.app.confirmForm.show(_.bind(function(){
        global.bookedby.helpers.confirmLogoutEvent(true);
        bookedby.app.logOut();
      }, this), function() {}, options);
    } else {
      bookedby.app.navigateTo(route);
    }
  }
});

module.exports = AccountSidebarView;